(function () {

    "use strict";

    function LoginController(auth, $translate, $location, $state, $scope, $rootScope, $mdDialog,$mdToast, TENANT) {

        var vm = this;

        vm.tenant = TENANT.URL;
        vm.user = {
            username: "",
            password: ""
        };
        vm.errorMessage = "";
        vm.login = login;
        vm.cancel = cancel;
        vm.hide = hide;

        if (window.innerWidth < 768) {
            showMobileModal();
        }
      

        function login(loginForm) {

            if (loginForm.$valid) {
                vm.errorMessage = "";
                auth.login(vm.user.username, vm.user.password, vm.tenant)
                    .catch(function (error) {
                        var messageKey;
                        messageKey = "AUTH.INVALID_LOGIN";
                        if (error.data.error_description === "INVALID_CREDENTIALS") {
                            messageKey = "AUTH.INVALID_LOGIN";
                        }
                        console.log(messageKey);
                        console.log(error);
                        $mdToast.show($mdToast.simple().textContent($translate.instant(messageKey)).position('top right').theme('error-toast').hideDelay(3000));

                        // Cierre de conexion SignalR.
                        if (window.conexionHub) {
                            window.conexionHub.stop();
                        }
                    })
                    .finally(function () {
                     
                    });
            } else {
                $mdToast.show($mdToast.simple().textContent($translate.instant("AUTH.INVALID_LOGIN")).position('top right').theme('error-toast').hideDelay(3000));
            }
        }

        function showMobileModal() {
            $mdDialog.show({
                controller: $rootScope.$new(true),
                contentElement: '#mobileMessage',
                parent: angular.element(document.body),
                clickOutsideToClose: true              
            });
        }

        function cancel() {
            console.log('cancel');
            $mdDialog.cancel();
            $mdDialog.hide('');
        }

        function hide() {
            $mdDialog.hide();
        }

    }

    LoginController.$inject = ["sphForms.loginService", "$translate", "$location", "$state", "$scope", "$rootScope", "$mdDialog","$mdToast", "TENANT"];

    angular.module("sphForms.auth")
        .component("sphFormsLogin", {
            controller: LoginController,
            templateUrl: "modules/auth/components/login/login.template.html"
        });

}());
